import {handleLogout} from "components/utils"; import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Button, Col, Form, Row} from "react-bootstrap";
import axios from "axios";
import 'react-vertical-timeline-component/style.min.css';
import {VerticalTimelineElement} from 'react-vertical-timeline-component';


export const ProcedureView = (props: { cookieEntityQr: string, data: any, reloadMethod: any, editMethod: any, caseStatus: string }) => {


    const handleDeleteProcedureModal = () => {
        axios.get('/api/backend/ipd/case/audit/remove/' + props.data.id)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                props.reloadMethod()
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    return (
        <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{background: '#ebecff', color: 'black'}}
            contentArrowStyle={{borderRight: '7px solid  #ebecff'}}
            date={props.data.createdAt + " - " + (props.data.createdByName && props.data.createdByName.split("@")[0])}
            iconStyle={{background: "#ebecff", fontSize: 25, textAlign: "center"}}
            icon="🪡"
        >
            <div className="d-flex justify-content-between">
                <div>
                    <div className="d-flex gap-2">
                        <div className="fs-6 text-secondary align-self-center">Doctor:</div>
                        <div className="fs-6 font-weight-bold"> {props.data.drInCharge}</div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="fs-6 text-secondary align-self-center">Procedure:</div>
                        <div className="fs-6 fw-bold d-inline-block"> {props.data.procedureName}</div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="fs-6 text-secondary">Procedure Details:</div>
                        <div className="fs-6  d-inline-block" dangerouslySetInnerHTML={{__html: props.data.procedureDetails}}/>
                    </div>
                </div>
                {props.caseStatus != "CLOSED" && <div>
                    <a href="#/" className="text-primary font-weight-bold"
                       onClick={e => props.editMethod(props.data)}>&#x270E;</a>
                    <a href="#/" className="text-decoration-none remove font-weight-bold"
                       onClick={handleDeleteProcedureModal}>&nbsp;&nbsp;&nbsp;&nbsp;X</a>
                </div>}
            </div>
        </VerticalTimelineElement>
    );
}